import { Helpers } from "@ora/recursos";
import { useCallback, useEffect, useState } from "react";
let { getAuthorization } = Helpers.ValidationAuth;
let { baseUrl } = Helpers.Url;
const ElementoImagenRandom =  (props) => {
  
  const getUrlImagenCarpeta = useCallback(() =>  {
    return (
      baseUrl("biodiversidad/plineancore/img/") +
      props.data.has_dir_file +
      "?token=" +
      getAuthorization().replace("Basic", "").replace(" ", "").trim()
    );
  }, [props.data]);

  const getUrlImagen = useCallback(() => {
    let r_url = "";
    //alert(baseUrl)
    if (!props.data.pli_txt_url_image1) {
      if (props.data.has_dir_file) {
        r_url = getUrlImagenCarpeta();
      } else {
        r_url = baseUrl("imagen/cites/Imagen_por_defecto.png");
      }
    } else {
      r_url = props.data.pli_txt_url_image1;
    }

    return r_url;
  }, [props.data, getUrlImagenCarpeta]);

  

  
    return (
      <div className="column">
        <div className="card jsoft-bd-0">
          <div className="card-content jsoft-pad-0">
            <div className="media mb-3">
              <div className="media-content">
                <hr className="jsoft-hr-100 jsoft-green-bg" />
                <p className="title is-5 jsoft-green pl-1">
                  <i>{props.data.pli_txt_scientificname}</i>
                </p>
                <div className="subtitle is-7 pl-1 pr-1">
                  <div className="tags has-addons">
                    <span className="tag has-background-success-light">
                      Apendice {props.data.pli_txt_cite}
                    </span>
                    <span className="tag has-background-warning-light">
                      {" "}
                      {props.data.pli_txt_uicn}
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <div className="content">
              {props.data.pli_txt_fulldescription}
            </div>
          </div>
          <div className="card-image">
            <figure className="image is-4by3">
              <img src={getUrlImagen()} alt="" />
            </figure>
          </div>
        </div>
      </div>
    );
  
}

export default ElementoImagenRandom